import $ from 'jquery';
import flatpickr from 'flatpickr';
import datePickerlanguage from 'flatpickr/dist/l10n/zh';

import '../css/common/common.css';
import '../css/common/content-wrapper.css';
import '../css/common/banner-wrapper.css';
import '../css/common/pattern-cover.css';
import '../css/common/section-block.css';
import '../css/common/button-effect.css';
import '../css/contact-block.css';

import '../css/image-block.css';
import '../css/room/room-table.css';
import '../css/room/room-note.css';
import '../css/room/section-block.css';

import '../css/common/booking-bar.css';
import '../css/index/promotion-wrapper.css';
import '../../node_modules/flatpickr/dist/flatpickr.min.css';
import '../../node_modules/flatpickr/dist/themes/airbnb.css';
import '../css/room/datepicker.css';

import '../js/importCommonCss';
import setup from './setupCommonJS';
import wordingSetter from './wordingSetter';
import getWordingJson from './request/wordingJson';
import setBookingLink from './setBookingLink';
import urlParser from './urlParser';
import hideLoadingImage from './common/hideLoadingImage';

setup();

getWordingJson('room')
	.then((json) => {
		wordingSetter(json);

		hideLoadingImage();
	});

setBookingLink($('.contact-block.-booking'));
/**
 * enable booking module in mobile device
 */
if (window.innerWidth < 768) {
	$('.button-effect.-openBooking').on('click', () => {
		$('.booking-bar').addClass('-show');
	});

	$('.booking-bar > .closebtn').on('click', () => {
		$('.booking-bar').removeClass('-show');
	});
}
/**
 * datepicker setting
 */
const zhTW = (urlParser.language === 'tw') ? datePickerlanguage.zh : '';

flatpickr('.booking-bar > .item:first-child > input', {
	locale: zhTW,
	minDate: 'today',
	disableMobile: true,
});



// WEBPACK FOOTER //
// ./src/js/rooms.js